<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="cachePages" :exclude="[]">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script setup lang="ts">
import { useBaseStore } from '@/stores/base'
import router from '@/router'
import {
  getUserInfo,
  getAppRequestHeader,
  registerPreviousH5
} from '@/utils/native'
import { ref } from 'vue'
import VConsole from 'vconsole'
if (import.meta.env.MODE !== 'prod') {
  new VConsole()
}
console.log('app-111')

getAppRequestHeader()

const { cachePages, setCachePages, removeCachePages } = useBaseStore()
const setBaseCachePage = () => {
  const openCacheRoute = router.options.routes
  openCacheRoute.map((c: any) => {
    if (c.meta?.keepAlive && c.name) {
      setCachePages(c.name)
    }
  })
}
// 初始化缓存页面
setBaseCachePage()

let timer: any = ref(null)
// 动态缓存
router.beforeEach((to: any, from: any, next) => {
  if (to.query?._t === undefined) {
    //用时间戳来判断前进后退
    to.query._t = new Date().getTime()
    next({
      path: to.path,
      query: to.query
    })
  } else {
    if (to.query?._t && from.query?._t) {
      if (to.query._t - from.query._t > 0) {
        //前进
        if (timer.value) {
          clearTimeout(timer.value)
        }
        timer.value = setTimeout(() => {
          if ('isDynamic' in to.meta && to.name) {
            to.meta.isDynamic = !to.meta.isDynamic
            setCachePages(to.name)
          }
        }, 100)
      } else {
        //后退
        if ('isDynamic' in from.meta && from.name) {
          from.meta.isDynamic = !from.meta.isDynamic
          removeCachePages(from.name)
        }
      }
    }
    next()
  }
})
getUserInfo()
registerPreviousH5()
</script>

<style lang="less">
@import url('@/styles/reset.less');
</style>
